
// import { RESIZE_DEBOUNCE } from '../constants';

export default class Accordion {

  constructor(context = null) {
    this.textSelector = '.field-accordion-item-content';
    this.labelSelector = '.field-accordtion-item-header';

    this.elements = document.querySelectorAll('.paragraph--type--accordion-item');

    if (!!this.elements && (context == document || (!!context && context.classList.contains('faq-page--block-1')))) {
      this.setup();
    }
  }

  setup() {

    this.elements.forEach((accordion) => {
      const accordionHeader = accordion.querySelector(this.labelSelector);
      const accordionText = accordion.querySelector(this.textSelector);

      if (!accordionHeader || !accordionText) return;

      // Hide accordion text
      // accordionText.style.display = 'none';

      accordion.classList.remove('active');

      // Display on toggle
      accordionHeader.addEventListener('click', function(){
        accordion.classList.toggle('open');
      });
    });
  }
}
